import * as React from "react";
import { Card } from "antd";
import "antd/dist/antd.css";
import "./LoginText.scss";

export default function LoginText() {
  return (
    <div>
      <Card type="inner" className="loginPage-basic">
        <p>若您已是新東陽會員，首次登入帳號密碼預設如下</p>
        <br />
        <br />
        <p style={{ color: "red" }}>門市快速註冊、紙本申辦(含舊制)之會員</p>
        <p>帳號: 手機號碼</p>
        <p>密碼: 生日(西元年月日共8碼，如:19801201)</p>
        <p>
          為維護您的會員權益，登入後請再次確認您的會員資料、修改密碼並妥善保存，以免權益受損。
        </p>
        <br />
        <br />
        <br />
        <br />
        <p>官網會員專區註冊之會員</p>
        <p>帳號: 手機號碼</p>
        <p>密碼: 同官網會員註冊專區之會員</p>
        <br />
        <br />
        <p>若您已登入過APP，請以相同的帳號密碼登入即可</p>
      </Card>
    </div>
  );
}
